import { render, staticRenderFns } from "./UserRegistrationFlow.vue?vue&type=template&id=68dafa3b&scoped=true&"
import script from "./UserRegistrationFlow.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationFlow.vue?vue&type=script&lang=js&"
import style0 from "./UserRegistrationFlow.vue?vue&type=style&index=0&id=68dafa3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dafa3b",
  null
  
)

export default component.exports